<div class="searchLeftPartTour">
    <mat-list>
        <mat-list-item [ngClass]="{'selectedItem': selectedType === 'keywords'}" class="listItem" style="height:auto;" (click)="openCriterionPage('keywords')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.filtre_mots_cles"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Mots-clés</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('keywords')}}</p>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item [ngClass]="{'selectedItem': selectedType === 'sectors'}" class="listItem" style="height:auto;" (click)="openCriterionPage('sectors')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.filtre_secteurs"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Secteurs d'activité</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('sectors')}}</p>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item [ngClass]="{'selectedItem': selectedType === 'veilleAugmentee'}" class="listItem" style="height:auto;" (click)="openCriterionPage('veilleAugmentee')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.filtre_veille"/>
                <div style="flex: 1">
                    <p style="margin: 0;">{{userService.sessionData.customerDetails.companyName}}</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('veilleAugmentee')}}</p>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item [ngClass]="{'selectedItem': selectedType === 'topics'}" class="listItem" style="height:auto;" (click)="openCriterionPage('topics')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.tag_theme"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Événements économiques</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('topics')}}</p>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item [ngClass]="{'selectedItem': selectedType === 'locations'}" class="listItem" style="height:auto;" (click)="openCriterionPage('locations')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.localisations"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Localisations</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelectedLocalisation('locations')}}</p>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item [ngClass]="{'selectedItem': selectedType === 'companySizes'}" class="listItem" style="height:auto;" (click)="openCriterionPage('companySizes')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.filtre_donnees_entreprise"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Données d'entreprise</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('companySizes')}}</p>
                </div>
            </div>
        </mat-list-item>
        <!-- Sans l'option "données institutionnelles" : entrée désactivée, le clic présente l'option -->
        <mat-list-item *ngIf="decisionsAdminEnabled" [ngClass]="{'selectedItem': selectedType === 'decisionsAdmin', 'disabledItem': !hasInstitutionalData}" class="listItem" style="height:auto;" (click)="openDecisionsAdmin()">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.decision_admin"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Décisions administratives</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('decisionsAdmin')}}</p>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="hasInstitutionalData" [ngClass]="{'selectedItem': selectedType === 'sourceOrigins'}" class="listItem" style="height:auto;" (click)="openCriterionPage('sourceOrigins')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.filtre_origine_source"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Origine de la source</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('sourceOrigins')}}</p>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="hasInstitutionalData" [ngClass]="{'selectedItem': selectedType === 'donneesChiffrees'}" class="listItem" style="height:auto;" (click)="openCriterionPage('donneesChiffrees')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.donnees_chiffrees"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Données chiffrées</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('donneesChiffrees')}}</p>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item [ngClass]="{'selectedItem': selectedType === 'activityTypes'}" class="listItem" style="height:auto;" (click)="openCriterionPage('activityTypes')">
            <div class="categoryBtn">
                <fe-icon [iconType]="IconType.nature_locaux"/>
                <div style="flex: 1">
                    <p style="margin: 0;">Nature des locaux</p>
                    <p style="font-size: 14px; color: #475A66;margin: 0;">{{getNumberCriterionSelected('activityTypes')}}</p>
                </div>
            </div>
        </mat-list-item>
    </mat-list>
</div>
